import React, { useEffect } from "react";
import $ from "jquery";
import AboutComponent from "../components/about/about";
import Banner from "../components/banner/banner";
import ContactComponent from "../components/contact/contact";
import Industries from "../components/industries/industries";
import ProductsCategory from "../components/products/productscategory";
function HomePage() {
  return (
    <>
      <Banner />
      
      <AboutComponent>
        <div className="content-img">
          <img alt="about us" src={"assets/img/about-img.png"} />
        </div>
        <p>
          AM-PM Engineering, an&nbsp;Indian&nbsp;company,&nbsp;is a global
          trader &amp; manufacturer of&nbsp;engineered
          Industrial&nbsp;components.
        </p>

        <p>
          Our management acquired its roots in the marketplace for over forty
          years through trading&nbsp;of the finest quality of industrial &amp;
          hardware products. With our roots firmly planted, AM-PM Engineering
          has expanded its business in the&nbsp;manufacturing sector of
          industrial Products.&nbsp;Every organization we work with benefits
          from over 40 years of experience, innovation, and techniques that have
          redefined the manufacturing industry which consistently delivers value
          through our engineering expertise, efficient operations, and
          Systematic Quality Planning systems.
        </p>

        <p>
          With&nbsp;a proper mix of talent &amp; experience in this field, AM-PM
          Engineering has a dedicated team with technical expertise, that
          provides best possible Product services to our customer in&nbsp;given
          time.
        </p>

        <p>
          Our&nbsp;Inquiry services will be handled via the Internet, where a
          client sends a detailed&nbsp;Product CAD file to our secured Email
          ID’s.&nbsp;If&nbsp;not&nbsp;possible&nbsp;to&nbsp;send technical
          drawing&nbsp;customer&nbsp;can&nbsp;also&nbsp;send&nbsp;Right Product
          sample as we have team to work on 3D Cad Modelling &amp; Drafting
          software through which we can help customer make Product drawing and
          get it approved.&nbsp;Product Costing is calculated based on 3D Cad
          Software which help us give Correct &amp; Accurate Cost of
          that&nbsp;product to client.
        </p>
        <a href="/about-us" className="btn btn-primary btn-primary-dark">
          Read More...
        </a>
      </AboutComponent>

      <ProductsCategory />
      <Industries>
        <div className="row">
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="1" src={"assets/img/industries/1.jpg"} />
            </div>
            <h3>Petro Chemicals </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="2" src={"assets/img/industries/2.jpg"} />
            </div>
            <h3>Power Generation </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="3" src={"assets/img/industries/3.jpg"} />
            </div>
            <h3>Automobiles </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="4" src={"assets/img/industries/4.jpg"} />
            </div>
            <h3>Nuclear </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="5" src={"assets/img/industries/5.jpg"} />
            </div>
            <h3>Chemicals </h3>
          </div>
          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="6" src={"./assets/img/industries/6.jpg"} />
            </div>
            <h3>Oil &amp; Gas</h3>
          </div>

          <div className="col-6 col-md-3">
            <div className="img-wrap">
              <img alt="7" src={"assets/img/industries/10.jpg"} />
            </div>
            <h3>Ship Building </h3>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <a
              href="/industries-we-serve"
              className="btn btn-primary btn-primary-dark"
            >
              View All
            </a>
          </div>
        </div>
      </Industries>
      <ContactComponent />
    </>
  );
}

export default HomePage;
